import { fromClassArray } from "fw-model";

export enum AccountType {
    Customer,
    Demo,
    Internal,
    Template,
    Testing
}

export type AtsOrganizationFilter = {
    type?: AccountType;
    mapping?: string;
    tags?: string[];
};

export class CalculatedFieldValue {
    FieldKey: string = null;
    Value: string = null;
}

export class EntitySelection {
    ids: string[] = [];
    excludedIds: string[] = [];
    filter: string = null;
    contact_type?: string = null;
}

interface Features {
    InterviewPortal: boolean;
    AssignmentNotifications: boolean;
    Decisions: boolean;
    ReviewPortal: boolean;
    AiFeatures: boolean;
}

export class AtsOrganization {
    Id: string;
    Name: string;
    Domain: string;
    Timezone: string;
    CountryCode: string;
    IsActive: boolean;
    ActiveSeasonId: string;
    SalesForceId: string;
    Type?: AccountType;
    Tags?: string[] = [];
    Features?: Features = null;
    @fromClassArray(CalculatedFieldValue) PropertyValues: CalculatedFieldValue[];
}

export type AtsOrgnaizationIdName = Pick<AtsOrganization, "Id" | "Name">;

export class AtsOrganizationPostArgs {
    Id?: string = null;
    Name: string = null;
    Timezone: string = null;
    Domain: string = null;
    ReferencePortalDomain: string = null;
    SalesForceId: string = null;
    SeasonName: string = null;
    Type?: AccountType = null;
    Tags?: string[] = null;
    Features?: Features = null;
    @fromClassArray(CalculatedFieldValue) PropertyValues: CalculatedFieldValue[];
}

export class AtsOrganizationPutArgs {
    Name: string = null;
    Timezone: string = null;
    Domain: string = null;
    Type?: AccountType = null;
    SalesForceId: string = null;
    Features?: Features = null;
    @fromClassArray(CalculatedFieldValue) PropertyValues: CalculatedFieldValue[];
}

export type SelectionItem = {
    label: string;
    value: string | number;
};

export enum FilterKeys {
    selectedMappings,
    selectedTypes,
    selectedTags
}
